// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1wVGJ","container":"styles_container__2beyR","title":"styles_title__3gvGv","wrapper":"styles_wrapper__2wmVH","answer":"styles_answer__3-gcX"};